import {Component, OnInit, Inject, DestroyRef, inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TagService} from '@emm/core/services/tag.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {NotificationService} from '@emm/shared/services/notification.service';

@Component({
    selector: 'emm-duplicate-consumer-dialog',
    styleUrls: ['./duplicate-consumer-dialog.component.scss'],
    templateUrl: './duplicate-consumer-dialog.component.html'
})
export class DuplicateConsumerDialogComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<DuplicateConsumerDialogComponent>,
        public dialog: MatDialog,
        public tagService: TagService,
        public managementApiService: ManagementApiService,
        public notificationService: NotificationService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.buildForm();
    }

    closeAfterSubmit(): void {
        const result = {
            name: this.form.controls.name.value,
            tag: this.form.controls.tag.value,
            };
        this.dialogRef.close(result);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    buildForm(): void {
        this.form = new FormGroup({
            name: new FormControl(''),
            tag: new FormControl(''),
        });
    }

    findTagExists(): void {
        if (this.form.controls.tag.valid) {
            this.tagService
                .getConsumerTags(this.form.get('tag').value)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(res => {
                    if (res) {
                        this.form.controls.tag.setErrors({ tagExists: true });
                    }
                });
        }
    }

    OnSubmit(): void {
        if (this.form.valid) {
            this.closeAfterSubmit();
        }
    }

}
